import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { TourV2ContentSections } from 'constants/tours'

function useTourV2ContentSectionLabels(): Record<TourV2ContentSections, string> {
  const intl = useIntl()

  return useMemo(() => ({
    [TourV2ContentSections.OVERVIEW]: intl.formatMessage({
      id: 'KixEEk8vAP',
      defaultMessage: 'Overview',
      description: 'Tour section label for the overview section',
    }),
    [TourV2ContentSections.PREFERRED_PACKAGES]: intl.formatMessage({
      id: 'GVb6siHXsH',
      defaultMessage: 'Select your preferred package',
      description: 'Tour section label for selecting preferred package',
    }),
    [TourV2ContentSections.ITINERARY]: intl.formatMessage({
      id: 'FT/Xo6OJ0a',
      defaultMessage: 'Itinerary',
      description: 'Tour section label for the itinerary section',
    }),
    [TourV2ContentSections.VARIATIONS]: intl.formatMessage({
      id: 'S5FTh8WdgH',
      defaultMessage: 'Variations',
      description: 'Tour section label for the variations section',
    }),
    [TourV2ContentSections.INCLUSIONS]: intl.formatMessage({
      id: 'omKGISQLvQ',
      defaultMessage: 'Highlights & inclusions',
      description: 'Tour section label for highlights and inclusions section',
    }),
    [TourV2ContentSections.DEPARTURES]: intl.formatMessage({
      id: 'RfmRyNZVWN',
      defaultMessage: 'Dates & pricing',
      description: 'Tour section label for dates and pricing section',
    }),
    [TourV2ContentSections.FINE_PRINT]: intl.formatMessage({
      id: 'NNOmV1zigA',
      defaultMessage: 'Things to know',
      description: 'Tour section label for fine print/things to know section',
    }),
    [TourV2ContentSections.FAQ]: intl.formatMessage({
      id: 'fQ0xs2JgX0',
      defaultMessage: 'Frequently Asked Questions',
      description: 'Tour section label for FAQ section',
    }),
    [TourV2ContentSections.YOU_MAY_ALSO_LIKE]: intl.formatMessage({
      id: 'CbD3o6RFkh',
      defaultMessage: 'You may also like',
      description: 'Tour section label for recommendations section',
    }),
    [TourV2ContentSections.REVIEWS]: intl.formatMessage({
      id: 'QNA8/OngAn',
      defaultMessage: 'Reviews',
      description: 'Tour section label for reviews section',
    }),
    [TourV2ContentSections.ADDITIONAL_WAYS]: intl.formatMessage({
      id: 'CTIn7h96GG',
      defaultMessage: 'Additional ways to experience this tour',
      description: 'Tour section label for additional tour variations',
    }),
    [TourV2ContentSections.SIMILAR_TOURS]: intl.formatMessage({
      id: 'bFEoufjEdG',
      defaultMessage: 'View Similar tours',
      description: 'Tour section label for similar tours section',
    }),
    [TourV2ContentSections.DEPARTURE_DATES]: '',
    [TourV2ContentSections.GALLERY]: '',
  }), [intl])
}

export default useTourV2ContentSectionLabels
